const get = (key) => {
  const read_cookies = document.cookie
  const split_read_cookie = read_cookies.split(`; ${key}=`)
  if (split_read_cookie.length === 2) return split_read_cookie.pop().split(';').shift();
  return false
};

export default {
  get
};
